<template>
  <div
    :class="[
      $b({
        'comparison-mode': comparisonMode,
        'cross-sell-rating': crossSellMode,
        'review-mode': reviewMode,
        'header-mode': headerMode,
        inline: inline,
      }),
      { [`ReviewStars__size-${size}`]: !!size },
    ]"
  >
    <div :class="$b('stars')">
      <BaseHeading
        v-if="comparisonMode"
        tag="h5"
        size="h5"
        :class="$b('comparison-heading')"
      >
        {{ $tn(rating || 0, 1) }} / 5
      </BaseHeading>

      <StarRatings
        :cross-sell-mode="crossSellMode"
        :review-mode="reviewMode"
        :header-mode="headerMode"
        :inline="inline"
        :rating="rating"
        :size="size"
        :gradient-light="gradientLight"
        :comparison-mode="comparisonMode"
      />

      <BaseHeading
        v-if="crossSellMode"
        tag="h5"
        size="h5"
        :class="$b('cross-sell-heading')"
      >
        {{ $tn(rating || 0, 1) }} / 5
      </BaseHeading>

      <BaseHeading
        v-if="headerMode"
        tag="h2"
        size="h2"
        :class="$b('header-mode-heading')"
      >
        {{ $tn(rating || 0, 1) }} / 5
      </BaseHeading>

      <BaseCopy
        v-if="crossSellMode || headerMode"
        tag="p"
        size="body"
        :class="$b('verified-text')"
      >
        {{
          $tr('from {count} verified customer reviews', { count: $tn(count) })
        }}
      </BaseCopy>

      <h3
        v-if="showLargeNumber"
        :class="$b('large-number')"
      >
        {{ $tn(rating || 0, 1) }}
      </h3>
    </div>

    <BaseCopy
      v-if="!showLargeNumber && showText && count && !headerMode && !mode"
      size="h5"
      :class="$b('rating')"
    >
      <b>{{ $tn(rating || 0, 1) }}</b>
      ({{ $tn(count || 0) }})
    </BaseCopy>

    <BaseCopy
      v-if="mode === 'count'"
      size="body"
      :class="$b('rating', { mode })"
    >
      {{ $tn(count || 0) }}
      <span :class="$b('label')">{{ $tr('Reviews') }}</span>
    </BaseCopy>

    <BaseCopy
      v-if="mode === 'score-from-count'"
      size="body"
      :class="$b('rating', { mode })"
    >
      <b>{{ $tn(rating || 0, 1) }}</b> {{ $tr('from') }} {{ $tn(count || 0) }} {{ $tr('reviews') }}
    </BaseCopy>
  </div>
</template>

<script>
export default {
  name: 'ReviewStars',

  props: {
    rating: { type: Number, default: 5 },
    count: { type: Number, default: 0 },
    showText: { type: Boolean, default: true },
    showLargeNumber: { type: Boolean, default: false },
    crossSellMode: { type: Boolean, default: false },
    comparisonMode: { type: Boolean, default: false },
    reviewMode: { type: Boolean, default: false },
    mode: { type: String, default: '', validator: (str) => ['', 'score-from-count', 'count'].includes(str)},
    headerMode: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    size: {
      type: String,
      default: '',
      validator: (str) => ['', 'base', 'sm', 'md', 'lg', 'xl'].includes(str),
    },
    gradientLight: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss">
.ReviewStars {
  &--review-mode {
    .ReviewStars__rating {
      line-height: 30px;
      vertical-align: text-bottom !important;
    }

    .ReviewStars__stars {
      @apply p-0
        text-left;
      -webkit-tap-highlight-color: transparent;
    }
  }

  &--header-mode {
    .ReviewStars__stars {
      @apply flex flex-wrap justify-start items-end
        pt-xs pb-md md:py-0 sm:pr-xxs
        text-left;
    }

    .ReviewStars__header-mode-heading {
      @apply mt-0 ml-xs md:ml-sm;
    }

    .ReviewStars__verified-text {
      @apply mt-xxs
        text-left
        w-full;
    }
  }

  &--cross-sell-rating {
    .ReviewStars__stars {
      @apply text-left
        w-full;
      margin: 10px 0 10px 0;
    }

    .ReviewStars__cross-sell-heading {
      @apply inline-block
        m-0
        relative;
      padding-left: 10px;
      line-height: 30px;
      top: 4px;
      font-size: 14px;
    }

    .ReviewStars__verified-text {
      @apply mt-0;
      font-size: 0.85em;
    }
  }

  &--inline {
    @apply flex items-center;

    .ReviewStars__rating {
      @apply mt-[4px] md:mt-[3px];
      margin-left: theme('spacing.xxs');

      &--mode-score-from-count {
        @apply mt-[6px] ml-xxs font-medium text-xxs;

        @screen md {
          @apply text-sm;
        }
      }
    }

    .ReviewStars__label {
      @apply text-xxs;

      @screen md {
        @apply text-sm;
      }
    }
  }

  &--comparison-mode {
    .ReviewStars__stars {
      @apply flex items-center flex-wrap;
    }

    .ReviewStars__comparison-heading {
      @apply text-sm md:text-base mr-xxxs leading-normal t-align-fix font-semibold;
    }
  }

  &__large-number {
    @apply px-sm m-0
      inline-block
      align-middle;
  }
}
</style>
